const VoucherRequestStatus = {
  INITIAL: 0,
  APPROVE: 1,
  CANCEL: 2,
  STOP: 3
}
export default VoucherRequestStatus
